<template>
  <el-card>
    <template #header>
      <span>注册公司</span>
    </template>
    <el-form label-width="80px">
      <el-form-item label="公司名">
        <el-input style="width: 600px;height: 50px" v-model="companyName" placeholder="请输入公司名称"></el-input>
      </el-form-item>
      <el-form-item label="推广码">
        <el-input style="width: 600px;height: 50px" v-model="promoteUserId" placeholder="请输入推广码"></el-input>
      </el-form-item>
      <el-form-item label="营业执照">
        <el-upload
            ref="uUpload"
            :action="fileUploadUrl + userSuffix"
            :limit="1"
            list-type="picture-card"
            :data="extraData"
            :on-success="uploadSuccess"
            :on-remove="imgRemove">
          <i class="el-icon-plus"></i>
        </el-upload>
        <!-- max-count限制图片的数量，action为后端服务器地址 -->
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="medium" @click="comfirm">提交申请</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="medium" @click="returnBack">返回注册公司状态列表</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="30%">
      <span>请确认提交申请</span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="submitGraph">确 定</el-button>
  </span>
    </el-dialog>
  </el-card>
</template>
<script>
import API from "../../../../config/api";

export default {
  name:"RegisterCompany",
  data() {
    return {
      //注册公司相关参数
      companyName: '',
      promoteUserId: null,
      extraData: {
        flag: 2
      },
      fileUploadUrl: API.fileUpload,
      fileList: [],
      businessLicense: "", // 营业执照url
      userId: '',//登录用户
      dialogVisible: false, //确认注册公司对话框
    }
  },
  mounted() {
    // 注册公司
    // 接口：companyRegister
    // 参数：companyName、adminId
    this.userId = window.localStorage.getItem('userid');
    console.log('注册公司userId的值=', this.userId);
  },
  methods: {
    //返回已经注册的公司的列表
    returnBack(){
      this.$emit('returnBack');
    },
    //图片上传成功后，data为营业执照图片在后台的路径
    uploadSuccess(data) {
      console.log("data = ", data);
      this.businessLicense = data;
    },
    //图片移除
    imgRemove() {
      this.businessLicense = ""
    },
    //提交的对话框
    comfirm() {
      let self = this;
      if (this.companyName === '') {//公司名不为空
        self.$message({type: 'warning', message: '请输入公司名称'});
        return;
      }
      if (this.businessLicense == "") {
        self.$message({type: 'warning', message: '请上传营业执照'});
        return;
      }
      this.dialogVisible = true;
    },
    //提交注册公司申请
    submitGraph() {
      let self = this;
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        businessLicense: this.businessLicense,
        companyName: this.companyName,
        adminId: this.userId,
        promoteUserId: this.promoteUserId,  //推广码
      }

      this.$axiosRequest({
        url: API.companyRegister,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          console.log('res=', res)
          if (res.data > 0) {
            self.$message({type: 'success', message: '已提交注册申请，敬请等待'});
            this.$emit('returnBack');
          } else if (res.data == -1) {
            self.$message({type: 'warning', message: '公司被注册过'});
            this.dialogVisible = false;
            return;
          } else if (res.data == -3) {
            self.$message({type: 'warning', message: '一个账号只能注册一个公司,可以加入多个公司'});
            this.dialogVisible = false;
            return;
          }else{
            self.$message({type: 'warning', message: '内部错误'});
            this.dialogVisible = false;
            return;
          }
        }
      });


    }

  },

}
</script>
<style lang="less">
swiper {
  height: 400px;

  image {
    width: 100%;
  }
}

.user-info-content {
  font-weight: bold;
}

.info-title {
  font-size: 18px;
  font-weight: bold;
  color: #004768;
  font-family: '仿宋';
}

.info-content {
  font-size: 18px;
  font-family: '仿宋';
  // font-weight: bold;
}

.info-card {
  margin: 10px 15px 10px 15px; // 上 右 下 左
  padding: 24px;
  background-color: rgba(239, 239, 239, 0.9);
}

.info-card2 {
  margin: 10px 15px 10px 15px; // 上 右 下 左
  padding: 24px;
  // background-color:rgba(239, 239, 239, 0.9);
}

.info-content {
  margin: 10px 0px 10px 10px; // 上 右 下 左
  height: auto;
}

.title-style {
  font-size: 18px;
  font-weight: bold;
}

.title2-style {
  font-size: 15px;
  line-height: 40px;
}

.title3-style {
  font-size: 12px;
  line-height: 40px;
  color: gray
}

.button-group-card {
  margin: 10px 15px 10px 15px; // 上 右 下 左
  // background-color:rgba(240,240,240,0.5);
  padding: 24px;
}

.button-group-title {
  font-size: 18px;
  font-weight: bold;
}
</style>



